module.exports = __webpack_public_path__ + "media/B9.cdc6cfb4.mp3";